import React from 'react';
import { Button, Input, cn } from '@/ui';
import { QUICK_ADD_ROOMS } from './_constants';

// Quick-add chips + custom-name input for adding a new room/section to the
// active inspection. Stateless; data + handlers come from the parent.
// Lifted out of InspectionView.tsx during the 2026-05-01 split.

interface AddRoomFormProps {
  existingRoomNames: string[];
  newRoomName: string;
  setNewRoomName: (v: string) => void;
  onAdd: (name: string) => void;
  onCancel: () => void;
}

export const AddRoomForm: React.FC<AddRoomFormProps> = ({
  existingRoomNames,
  newRoomName,
  setNewRoomName,
  onAdd,
  onCancel,
}) => (
  <div className="mt-2 p-3 bg-surface-2 rounded-xl border border-border-subtle">
    <p className="text-overline uppercase tracking-wide text-ink-subtle mb-2">Quick add section</p>
    <div className="flex flex-wrap gap-1.5 mb-3">
      {QUICK_ADD_ROOMS.filter((name) => !existingRoomNames.includes(name)).map((name) => (
        <button
          key={name}
          type="button"
          onClick={() => onAdd(name)}
          className={cn(
            'px-2.5 py-1 bg-surface-1 border border-border-subtle rounded-full text-caption',
            'text-ink-muted hover:bg-brand-soft hover:border-brand/30 hover:text-brand transition-colors',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand',
          )}
        >
          {name}
        </button>
      ))}
    </div>
    <div className="flex gap-2">
      <Input
        inputSize="sm"
        value={newRoomName}
        onChange={(e) => setNewRoomName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onAdd(newRoomName);
        }}
        placeholder="Custom section name…"
        autoFocus
      />
      <Button
        size="sm"
        onClick={() => onAdd(newRoomName)}
        disabled={!newRoomName.trim()}
      >
        Add
      </Button>
      <Button
        size="sm"
        variant="ghost"
        onClick={onCancel}
      >
        Cancel
      </Button>
    </div>
  </div>
);
